<template>
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.6666 10.6859L29.3166 8.33594L19.9999 17.6526L10.6833 8.33594L8.33325 10.6859L17.6499 20.0026L8.33325 29.3193L10.6833 31.6693L19.9999 22.3526L29.3166 31.6693L31.6666 29.3193L22.3499 20.0026L31.6666 10.6859Z" fill="white"/>
</svg>
</template>